module.exports = __webpack_public_path__ + "img/coupons_bg2.4810c588.png";